import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteClinicConsultationService = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (consultationServiceId: string) => {
      return api.delete(`clinic/consultation-services/${consultationServiceId}`);
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "delete-consultation-service-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.consultationServices(),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Clinic Consultation Service]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.consultationServices(),
      });

      handleErrors(res, "mutation");
    },
  });
};
